import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import {
  MsalBroadcastService,
  MsalGuard,
  MsalGuardConfiguration,
  MsalInterceptor,
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
} from '@azure/msal-angular';
import {
  InteractionType,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';
import { ENV } from '@env/environment-token';
import { IEnvironmentVariables } from '@env/IEnvironment';
import { LoginComponent } from '@core/components/login/login.component';
import { API_URL, apiUrlFactory, API_PLATFORM_URL, apiPlatformUrlFactory } from '@core/config';

export function MSALInstanceFactory(
  envConfig: IEnvironmentVariables
): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      navigateToLoginRequestUrl: false,
      ...envConfig.authConfig.config.auth,
    },
  });
}

export function MSALGuardConfigFactory(
  envConfig: IEnvironmentVariables
): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: [...envConfig.authConfig.angularConfig.consentScopes],
    },
  };
}

export function MSALInterceptorConfigFactory(
  envConfig: IEnvironmentVariables
): MsalInterceptorConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap: new Map(
      envConfig.authConfig.angularConfig.protectedResourceMap
    ),
  };
}

@NgModule({
  declarations: [LoginComponent],
  imports: [CommonModule, MsalModule],
  providers: [
    MsalService,
    MsalGuard,
    MsalBroadcastService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
      deps: [ENV],
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: MSALGuardConfigFactory,
      deps: [ENV],
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: MSALInterceptorConfigFactory,
      deps: [ENV],
    },
    {
      provide: API_URL,
      useFactory: apiUrlFactory,
      deps: [ENV],
    },
    {
      provide: API_PLATFORM_URL,
      useFactory: apiPlatformUrlFactory,
      deps: [ENV],
    },
  ],
})
export class AuthenticationModule {}
